import { useAuth } from "react-oidc-context";
import { UserManager, UserManagerSettings, User } from "oidc-client-ts";
import { JSXElementConstructor, ReactElement, createContext } from "react";

interface IZitadelContext {
    logout(): void;
    user: User,
    getAccessTokenSilently(): Promise<string>;
}

export const ZitadelContext = createContext({} as IZitadelContext);

export const ZitadelProvider = (props: { 
    logoutRedirectUri: string;
    loginRedirectUri: string;
    children: ReactElement<any, string | JSXElementConstructor<any>>
}) => {

    const auth = useAuth();

    switch (auth.activeNavigator) {
        case "signinSilent":
            return <div>Signing you in...</div>;
        case "signoutRedirect":
            return <div>Signing you out...</div>;
    }

    if (auth.isLoading) {
        return <div>Loading...</div>;
    }

    if (auth.error) {
        return <div>Oops... {auth.error.message}</div>;
    }

    if(!auth.isAuthenticated && !auth.isLoading) {
        auth.signinRedirect({ 
            scope: "openid profile email urn:zitadel:iam:user:metadata urn:zitadel:iam:org:id:224315847907213569",
            redirect_uri: props.loginRedirectUri
        })
        return <div>Logging in...</div>;
    }

    if (auth.isAuthenticated) {
        return (
            <ZitadelContext.Provider
                value={{
                    user: auth.user!,
                    logout: () => void auth.signoutRedirect({ post_logout_redirect_uri: props.logoutRedirectUri }),
                    getAccessTokenSilently: () => new Promise<string>((resolve, reject) => resolve(auth.user!.access_token))
                }}
            >
                { props.children }
            </ZitadelContext.Provider>
        );
    } else {
        return <div>Failed to log in!</div>;
    }
};